import { api } from './apiClient';

const unwrapError = (error, fallback) => {
  if (error.response) {
    const data = error.response.data;
    if (Array.isArray(data?.errors)) return data.errors.join(', ');
    return data?.message || `Server error: ${error.response.status}`;
  }
  if (error.request) return 'Unable to reach the server. Please check your internet connection or try again later.';
  return error.message || fallback;
};

export const fetchModuleGroupingList = async (page = 1, pageSize = 50, searchtext = '') => {
  try {
    const response = await api.post('/api/v1/admin/module-groupings/list', {
      pagination: { page, pageSize },
      searchtext: searchtext || '',
    });
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to load module groupings'));
  }
};

export const createModuleGrouping = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/module-groupings', payload);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to create module grouping'));
  }
};

export const updateModuleGrouping = async (payload) => {
  try {
    const response = await api.put('/api/v1/admin/module-groupings', payload);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to update module grouping'));
  }
};

export const deactivateModuleGrouping = async (id) => {
  try {
    const response = await api.delete(`/api/v1/admin/module-groupings/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to deactivate module grouping'));
  }
};
